import { compact } from '../../../../helpers/compact';
import {
  FootnotesSlice,
  LaPosteEn4SliceType,
} from '../../../../types/page/la-poste-en-4';
import { toText } from '../../fields';

const footnotesSlice = (
  data: Record<string, any>
): FootnotesSlice | undefined =>
  compact({
    type: LaPosteEn4SliceType.FOOTNOTES,
    notes: data.items.map((note: any) =>
      compact({
        reference: toText(note.char),
        description: toText(note.description),
      })
    ),
  });

export default footnotesSlice;
